export const ANDROID_PACKAGE = "com.evidex.app";
export const IOS_BUNDLE_ID = "com.evidex.app";
const KEY = "apx_platform";

// Native store builds (Android TWA, iOS Capacitor shell) are consumption-only for subscriptions.
export const nativePlatform = () => {
  try {
    const src = new URLSearchParams(window.location.search).get("src");
    if (src === "twa" || document.referrer.startsWith(`android-app://${ANDROID_PACKAGE}`)) localStorage.setItem(KEY, "android");
    if (src === "ios" || window.Capacitor?.getPlatform?.() === "ios") localStorage.setItem(KEY, "ios");
    const v = localStorage.getItem(KEY);
    return v === "android" || v === "ios" ? v : null;
  } catch {
    return null;
  }
};
export const isNativeApp = () => nativePlatform() !== null;
export const isAndroidApp = isNativeApp;
